import { ActivatedRoute } from '@angular/router';

/** Maps to the corresponding property name on {@link ActivatedRoute}. */
export const routerParamTypeMapping = {
  data: 'data',
  query: 'queryParams',
  route: 'params',
} as const satisfies Record<string, keyof ActivatedRoute>;

export type RouterParamType = keyof typeof routerParamTypeMapping;
